import "./steps.css";
import { attachPropertiesToComponent } from '../../utils/attach-properties-to-component';
import { Step } from './step';
import { Steps } from './steps';
export default attachPropertiesToComponent(Steps, {
  Step
});